<script lang="ts">
    import MainLayout from "../../#common/layout/Layout.svelte"
    import { Table } from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'
    import {roundNumber} from 'src/components/#common/helpers'
    import { getSwapTransactions } from "../../#services/swapTransactions";

    const urlParams = new URLSearchParams(window.location.search);

    let currentPage = 0
    let perPage = 25
    let startDate = urlParams.get('startDate') || undefined
    let endDate = urlParams.get('endDate') || undefined
    let ligament = urlParams.get('ligament') || 'no'
    let supportId
    let sortBy = 'date'
    let maxDate = new Date()
    let dd = String(maxDate.getDate()).padStart(2, '0')
    let mm = String(maxDate.getMonth() + 1).padStart(2, '0')
    let yyyy = maxDate.getFullYear()
    maxDate = yyyy+'-'+mm+'-'+dd

    function filter() {
        getSwapTransactions.reset()
        getSwapTransactions.send({ data: {
            page: currentPage + 1,
            perPage,
            ligament: ligament === 'no' ? undefined : ligament,
            userId: supportId,
            startDate,
            endDate,
            sortBy
        }})
        $getSwapTransactions.value
    }

    function reset() {
        startDate = undefined
        endDate = undefined
        supportId = undefined
        ligament = 'no'
        sortBy = 'date'
        currentPage = 0
        filter()
    }

    $:currentPage,perPage,filter()
</script>

<svelte:head>
    <title>SWAP</title>
</svelte:head>

<MainLayout title="SWAP">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <div class="buttons">
                    <div class="pc-line">
                        <select class="form-select" bind:value={ligament}>
                            <option value="no">—</option>
                            <option value="WLIS/NEAR">LIS/NEAR</option>
                            <option value="WLIS/USDT">LIS/USDT</option>
                            <option value="NEAR/USDT">USDT/NEAR</option>
                            <option value="MATIC/USDT">MATIC/USDT</option>
                            <option value="WLIS/MATIC">WLIS/MATIC</option>
                        </select>
                    </div>
                    <div class="pc-line">
                        <input type="text" bind:value={supportId} class="form-control" placeholder="Support ID">
                    </div>
                    <div class="pc-line">
                        <select class="form-select" bind:value={sortBy}>
                            <option value="date">Latest</option>
                            <option value="amount">Amount</option>
                        </select>
                    </div>
                    <div class="pc-line">
                        <input type="date" bind:value={startDate} class="form-control" max="{maxDate}">
                    </div>
                    <div class="pc-line">
                        <input type="date" bind:value="{endDate}" class="form-control" max="{maxDate}">
                    </div>
                    <div class="pc-line">
                        <button class="btn btn-primary btn-filter" on:click={filter}>Filter</button>
                        <button class="btn btn-secondary" on:click={reset}>Reset</button>
                    </div>
                </div>
                {#if $getSwapTransactions.hasValue}
                    <PerPage
                        bind:perPage={perPage}
                        disabled={$getSwapTransactions.loading || $getSwapTransactions.loading}
                        totalCount={$getSwapTransactions.value.totalCount}
                    />
                {/if}
                <div class="transactions-list">
                    <Table bordered striped responsive>
                        <thead>
                        <tr>
                            <td class="text-center">From</td>
                            <td class="text-center">To</td>
                            <td class="text-center">Fee</td>
                            <td class="text-center">User</td>
                            <td class="text-center">Date</td>
                        </tr>
                        </thead>
                        <tbody>
                        {#if $getSwapTransactions.loading}
                            {#each {length:perPage} as item}
                                <tr>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                    <td><span class="loading transaction-loading"></span></td>
                                </tr>
                            {/each}
                        {:else if $getSwapTransactions.error || !$getSwapTransactions.hasValue}
                            <tr>
                                <td class="text-center" colspan="4">
                                    {#if $getSwapTransactions.error}
                                        {$getSwapTransactions.error}
                                    {:else}
                                        Something went wrong. Try refreshing the page.
                                    {/if}
                                </td>
                            </tr>
                        {:else}
                            {#each $getSwapTransactions.value.data as {userId, from, to, fromAmount, toAmount, fee, swapDate}}
                                <tr>
                                    <td class="text-center">-{roundNumber(+fromAmount)} {from === 'WLIS' ? 'LIS' : from}</td>
                                    <td class="text-center">+{roundNumber(+toAmount)} {to === 'WLIS' ? 'LIS' : to}</td>
                                    <td class="text-center">+{roundNumber(+fee)} {to === 'WLIS' ? 'LIS' : to}</td>
                                    <td class="text-center">
                                        {#if userId}
                                            <a href="profile/{userId}" class="reason" target="_blank" rel="noreferrer">{userId}</a>
                                        {/if}
                                    </td>
                                    <td class="text-center">{new Date(swapDate).toLocaleString()}</td>
                                </tr>
                            {:else}
                                <tr>
                                    <td class="text-center" colspan="4">No items</td>
                                </tr>
                            {/each}
                        {/if}
                        </tbody>
                    </Table>
                    {#if $getSwapTransactions.hasValue}
                        <PerPage
                            bind:perPage={perPage}
                            disabled={$getSwapTransactions.loading || $getSwapTransactions.loading}
                            totalCount={$getSwapTransactions.value.totalCount}
                        />
                        <Pagination
                            bind:currentPage={currentPage}
                            totalCount={$getSwapTransactions.value.totalCount}
                            {perPage}
                            disabled={$getSwapTransactions.loading || $getSwapTransactions.loading}
                        />
                    {/if}
                </div>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .buttons {
        margin-bottom: 15px;
    }

    .buttons .btn {
        margin-left: 5px;
    }

    .transaction-loading {
        height: 24px;
        width: 100%;
        display: block;
    }

    .btn-primary.btn-filter {
        padding: 8px 20px;
    }

    input[type="date"] {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    .btn.btn-secondary {
        padding: 10px 20px;
        font-size: 14px;
        line-height: normal;
        border: 0;
        box-shadow: none;
    }

    .pc-line {
        display: inline-block;
        margin-bottom: 10px;
        vertical-align: top;
    }

    @media(max-width: 767px) {
        .pc-line {
            display: block;
        }

        .pc-line .btn {
            margin-left: 0;
            width: 100%;
        }

        .btn-filter {
            margin-bottom: 10px;
        }
    }
</style>
